import { css, unsafeCSS } from 'lit';
import SotbitButton from '../button';
import styles from './button-fab.scss?inline';

export default class SotbitButtonFab extends SotbitButton {
    static styles = [
        SotbitButton.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];
}
